import React from "react";

const Footer = () => {
  return (
    <footer className="bg-light text-dark text-center py-3 mt-auto shadow-sm">
      <div className="container">
        <p className="mb-1">&copy; 2025 Haciali | Tüm hakları saklıdır.</p>
        <p className="mb-0">
          <a href="https://www.linkedin.com/in/haciali" className="text-primary text-decoration-none" target="_blank" rel="noopener noreferrer">LinkedIn</a> |
          <a href="https://github.com/haciali" className="text-primary text-decoration-none ms-2" target="_blank" rel="noopener noreferrer">GitHub</a> |
          <a href="/" className="text-primary text-decoration-none ms-2">Hakkında</a> |
          <a href="/iletisim" className="text-primary text-decoration-none ms-2">İletişim</a>
        </p>
      </div>
      {/* SEO için yapılandırılmış veri */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Person",
          "name": "Haciali",
          "url": "https://www.hacialikara.com",
          "sameAs": [
            "https://www.linkedin.com/in/haciali",
            "https://github.com/haciali"
          ],
          "jobTitle": "Software Developer",
          "worksFor": {
            "@type": "Organization",
            "name": "Haciali Inc."
          },
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Istanbul",
            "addressCountry": "Turkey"
          }
        })}
      </script>
    </footer>
  );
};

export default Footer;